<!--
 * @Author: your name
 * @Date: 2021-08-26 09:49:59
 * @LastEditTime: 2021-11-16 13:43:58
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/components/loading/loading.vue
-->
<template>
  <div class="loading">
    <van-popup v-model="show" :round="true" :close-on-click-overlay="false">
      <img class="load" src="../../assets/img/productDetail/loading.gif" alt="" />
    </van-popup>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.load {
  width: 80px;
  height: 80px;
  margin: 26px 30px;
}
::v-deep .van-overlay {
  background: rgba(0, 0, 0, 0.5);
}
::v-deep .van-popup--center.van-popup--round {
  border-radius: 16px !important;
}

</style>
